import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 bg-conversion z-[60] origin-left"
      style={{ scaleX }}
      data-testid="scroll-progress"
    />
  );
};

export default ScrollProgress;
